import { render, staticRenderFns } from "./DoctorNotAvailablePanel.vue?vue&type=template&id=37b873a1&scoped=true"
import script from "./DoctorNotAvailablePanel.vue?vue&type=script&lang=js"
export * from "./DoctorNotAvailablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b873a1",
  null
  
)

export default component.exports